<template>
    <tr :class="['clickable']" @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="entity.id"
               :value="entity.id"
               @click.stop
               @change="onChange"
               :checked="isChecked"
        />
        <label
            :for="entity.id"
            @click.stop
            v-translate>Vybrat
        </label>
      </td>
        <td :data-th="'Název' | translate" class="first_data"><strong>{{ entity.name }}</strong></td>
        <td :data-th="'Datum odeslání' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
        <td :data-th="'Počet příjemců' | translate" >{{ entity.recipients_count }}</td>
        <td :data-th="'Globální oznámení' | translate"><img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"  v-if="entity.global"/></td>
        <td :data-th="'Typ oznámení' | translate">{{ type }}</td>
        <td :data-th="'Odesilatel' | translate">
          <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
        </td>
        <td class="no_padding edit">
            <div class="edit_inner">
              <a
                  v-if="$_createActionAllowed"
                  class="btn btn_action btn_recipients btn_grey"
                  :title="'Převzít příjemce' | translate"
                  @click.prevent.stop="emitDuplicateRecipients"
                  v-translate>Převzít příjemce
              </a>
              <a
                  v-if="$_createActionAllowed"
                  class="btn btn_action btn_resend btn_grey"
                  :title="'Přeposlat oznámení' | translate"
                  @click.prevent.stop="emitForwardMessage"
                  v-translate>Přeposlat oznámení
              </a>
                <a
                    v-if="$_loggedUser_operator_item_delete_action_allowed(this.entity.id_operator)"
                    class="btn btn_action btn_delete"
                    :title="'Smazat' | translate"
                    @click.prevent.stop="emitDeleteMessage"
                    v-translate>Smazat
				</a>
            </div>
        </td>
    </tr>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"
import rowActions from "@/components/mixins/row-actions"
import loggedUser from "../../mixins/global/logged-user";
import EntityLink from "../../common/EntityLink.vue";
import types from "./mixins/types"

export default {
		name: "MessageRow",
    components: { EntityLink },
		data() {
			return {
				moduleName: 'messages',
        detailPageRouteName: 'messageDetail',
			}
		},
    mixins: [userSettings, rowActions, types, loggedUser],
		computed: {
      type() {
        let type = this.messageTypeOptions.find(o => o.id === this.entity.type);
        return (type && type.hasOwnProperty("text")) ? type.text : null;
      },
		},
		methods: {
			goToDetail(e, id) {
				this.$router.push({name: this.detailPageRouteName, params: {id: id}})
			},
			emitDeleteMessage() {
				this.$emit('deleteMessage', String(this.entity.id))
			},
      emitDuplicateRecipients(){
        this.$emit('duplicate-recipients', String(this.entity.id));
      },
      emitForwardMessage() {
        this.$emit('forward-message', String(this.entity.id));
      },
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/MessageRow.vue